
import loaderComponent from '@/components/loaderComponent';
import RentalTnCModal from '@/components/modals/RentalTnCModal.vue';
import NoContent from '@/components/customer-content/NoContent'
export default {
  layout: 'error-page',
  components: {
    NoContent,
    RentalTnCModal
  },
  head() {
    return {
      script: [{
        hid: "rzpay",
        rel: "dns-prefetch",
        src: "https://checkout.razorpay.com/v1/checkout.js",
        defer: true
      }],
      title: this.title + " | GoaApp",
      meta: [{
        hid: 'og:title',
        property: 'og:title',
        content: this.title + " | Goa App"
      },],
    }
  },
  data() {
    return {
      title: 'Rental Checkout',
      checkoutDetails: null,
      createOrderId: null,
      loading: true,
      payment_id: null,
      order_id: null,
      userId: null,
      token: null,
      profile: null,
      orderDetails: null,
      orderButtonLoading: false,
      orderFailed: false,
      selectedCartItem: 0,
      //Form error variables
      errors: {
        formError: null
      },
    };
  },
  // Check login token
  mounted() {
    if (localStorage.getItem("authToken") != (null || undefined)) {
      this.token = localStorage.getItem("authToken");
      if (localStorage.getItem("profile") != (null || undefined)) {
        this.profile = JSON.parse(localStorage.getItem("profile"));
      }
      this.getCheckoutDetails()
    } else {
      this.$router.push({
        path: '/accounts/login/'
      })
    }
    if(localStorage.getItem("taxiBooked") != (null || undefined)){
      this.$router.push({
        path: '/taxi'
      })
    }
  },
  methods: {
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
    },
    roundOffValue(num){
      return num.toFixed(2).replace(/\.00$/, '');
    },
    //------------------------------------------- CART FUNCTIONS -------------------------------------------//
    // TO get CHECKOUT DETAILS
    getCheckoutDetails() {
      this.loading = true;
      // Add header for the API
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': this.token
      };
      // AXIOS api call to add review api
      this.$axios.post("/api/taxiOrders/app/checkout", {}, {
        headers: headers
      })
        .then(response => {
          let value = this.getCryptKey(response.data);
          this.checkoutDetails = value;
          if(!this.checkoutDetails || !this.checkoutDetails.taxi){
            this.$router.push({
        path: '/taxi'
      })
          }
          this.loading = false;
        })
        .catch(error => {
          this.$nextTick(() => {
            this.$router.push({
              path: '/'
            })
            this.loading = false;
          })
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          })
        })
    },

    //------------------------------------------- CART FUNCTIONS END -------------------------------------------//

    //------------------------------------------- TRACKING FUNCTIONS START -------------------------------------------//
    getSctipt(value) {
      return `window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
          }; gtag('event', 'conversion', { 'send_to': 'AW-468546632/mFmrCLOFnv8CEMjotd8B', 'transaction_id': '${this.order_id}',  'currency': 'INR', 'value': '${value}'})`;
    },

    appendScript(value) {
      const script = document.createElement('script')
      script.text = this.getSctipt(value);
      document.getElementsByTagName('head')[0].appendChild(script)
    },

    //------------------------------------------- TRACKING FUNCTIONS END -------------------------------------------//

    //------------------------------------------- PAYMENT FUNCTIONS -------------------------------------------//
    createOrder() {
      this.orderButtonLoading = true;
      this.loading = true;
      var formData = new URLSearchParams();
      // Add header for the API
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': this.token
      };
      // AXIOS api call to add review api
      this.$axios.post("/api/taxiOrders/app/createTaxiOrder", formData, {
        headers: headers
      })
        .then(response => {
          let value = this.getCryptKey(response.data);
          this.createOrderId = value.orderId ? value.orderId : null;
        })
        .catch(error => {
          this.$nextTick(() => {
            this.$router.push({
              path: '/'
            })
            this.loading = false;
          })
        })
        .finally(() => {
          this.$nextTick(() => {
            this.order()
          })
        })
    },

    // To initiate payment api and open the razorpay pop up, also handles success and failure
    order() {
      this.errors.formError = null;
      this.orderButtonLoading = true;
      this.orderFailed = false;
      let date = new Date()
      const self = this;
      const rzp_options = {
        key: self.$config.rzpKey, // Enter the Key ID generated from the Dashboard
        amount: this.checkoutDetails.bookingAmount *
          100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: "INR",
        name: "GOA APP",
        description: 'Secure payments',
        image: "https://goa.app/goa-razorpay.png",
        order_id: this.createOrderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
        handler: function (response) {
          self.orderButtonLoading = false;
          let orderId = response.razorpay_order_id ? response.razorpay_order_id : null;
          let paymentId = response.razorpay_payment_id ? response.razorpay_payment_id : null;
          let signature = response.razorpay_signature ? response.razorpay_signature : null;
          self.errors.formError = "Do not press back or refresh, payment processing.";
          self.verifyPayment(paymentId, orderId, signature);
          self.payment_id = response.razorpay_payment_id;
        },
        modal: {
          ondismiss: function () {
            self.errors.formError = null;
            self.orderButtonLoading = false;
          }
        },
        prefill: {
          email: this.profile && this.profile.email ? this.profile.email : '',
          contact: this.profile && this.profile.phone ? this.profile.phone : ''
        },
        notes: {
          name: "Date",
          item: date
        },
        theme: {
          color: "#ff9012"
        }
      };
      const rzp1 = new Razorpay(rzp_options);
      rzp1.open();
      rzp1.on('payment.failed', function (response){
        this.orderFailed = true;
        this.errors.formError = null;
});
    },
    // Final step to verify if payment is done and redirect to orders page
    verifyPayment(paymentId, orderId, signature) {
      this.orderButtonLoading = true;
      this.orderFailed = false;
      var formData = new URLSearchParams();
      formData.append("paymentId", paymentId);
      formData.append("rentalOrderId", orderId);
      formData.append("signature", signature);
      this.order_id = orderId;
      localStorage.setItem("taxiBooked", true );
       this.$router.push({
              path: '/taxi-success/' + this.order_id
            })
        this.orderButtonLoading = false;
    },
    //------------------------------------------- PAYMENT FUNCTIONS END -------------------------------------------//
  }
}

